import "./index.css";
// src/ClickableOptions/ClickableOptions.tsx
import Icon from "@cloudscape-design/components/icon";

// src/ClickableOptions/ClickableOptions.module.scss
var ClickableOptions_module_default = {
  selectOption: "ClickableOptions_module_selectOption",
  selectText: "ClickableOptions_module_selectText",
  disabled: "ClickableOptions_module_disabled",
  selectContent: "ClickableOptions_module_selectContent",
  sendIcon: "ClickableOptions_module_sendIcon"
};

// src/ClickableOptions/ClickableOptions.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var ClickableOptions = ({
  options,
  onSelect,
  disabled = false,
  ariaLabel = "Select an option",
  logger
}) => {
  const handleSelect = (option) => {
    if (option && !disabled) {
      logger?.biMetric({
        metricName: "Click",
        unit: "Count",
        value: 1,
        dimensions: {
          ClickFeat: "chat-section",
          ClickObj: "clickable-option",
          ClickSelect: "clickable-option-text",
          ClickAct: "text"
        }
      });
      onSelect(option);
    }
  };
  const handleIconClick = (event, option) => {
    event.stopPropagation();
    if (option && !disabled) {
      logger?.biMetric({
        metricName: "Click",
        unit: "Count",
        value: 1,
        dimensions: {
          ClickFeat: "chat-section",
          ClickObj: "clickable-option",
          ClickSelect: "clickable-option-icon",
          ClickAct: "icon"
        }
      });
      onSelect(option);
    }
  };
  return /* @__PURE__ */ jsx("div", { role: "listbox", "aria-label": ariaLabel, children: options.map((option, index) => /* @__PURE__ */ jsx(
    "button",
    {
      type: "button",
      role: "option",
      "aria-selected": false,
      disabled,
      className: `${ClickableOptions_module_default.selectOption} ${disabled ? ClickableOptions_module_default.disabled : ""}`,
      onClick: () => handleSelect(option),
      children: /* @__PURE__ */ jsxs("div", { className: ClickableOptions_module_default.selectContent, children: [
        /* @__PURE__ */ jsx("span", { className: ClickableOptions_module_default.selectText, children: option }),
        /* @__PURE__ */ jsx("span", { className: ClickableOptions_module_default.sendIcon, onClick: (e) => handleIconClick(e, option), children: /* @__PURE__ */ jsx(Icon, { name: "send" }) })
      ] })
    },
    index
  )) });
};
export {
  ClickableOptions
};
//# sourceMappingURL=index.js.map
